import React from 'react';
import PropTypes from 'prop-types';
import { Col, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';
import Slider from '@material-ui/core/Slider';

class SummaryItem extends React.Component {
  render() {
    const potentialValue = this.props.potentialValue;
    let valuePrefix = '',
        valueSuffix = '';
    switch(this.props.valueType.toLowerCase()) {
      case 'money':
        valuePrefix = '$';
        break;
      case 'percent':
        valueSuffix = '%';
        break;
    }
    const layout = {
      currentValue: `${valuePrefix}${this.props.value.toLocaleString()}${valueSuffix}`,
      potentialValue: `${valuePrefix}${potentialValue.toLocaleString()}${valueSuffix}`,
      sliderValue: `${this.props.sliderValue}%`
    };
    
    function valuetext(value) {
    return `${value}%`;
    }

    const marks = [
      {
          value: 0,
          label: '0%',
      },
      {
          value: 100,
          label: '100%',
      },
    ];
    
    return (
      <FormGroup className="equal">
        <Col xs={12} sm={3} md={2}>
          <ControlLabel>{this.props.title}</ControlLabel>
        </Col>

        <Col xs={3} sm={2}>
          <FormControl.Static>{layout.currentValue}</FormControl.Static>
        </Col>

        <Col xs={6} sm={4} md={5}>
          {this.props.showSlider &&
          <div className="slider">
            <Slider
                defaultValue={this.props.sliderValue}
                onChange={this.props.onSliderValueChange}
                valueLabelFormat={valuetext}
                getAriaValueText={valuetext}
                step={1}
                marks={marks}
                valueLabelDisplay="on"
            />
          </div>}          
        </Col>
        
        <Col xs={3} sm={2} className="potential-column">
          <FormControl.Static>{layout.potentialValue}</FormControl.Static>
        </Col>
      </FormGroup>
    );
  }
}

SummaryItem.defaultProps = {
  initialSliderValue: 50,
  showSlider: true,
  valueType: "number"
};

SummaryItem.propTypes = {
  initialSliderValue: PropTypes.number,
  onSliderValueChange: PropTypes.func,
  onValueChange: PropTypes.func,
  potentialValue: PropTypes.number.isRequired,
  showSlider: PropTypes.bool,
  sliderValue: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.number.isRequired,
  valueType: PropTypes.string
};

export default SummaryItem;